export default __webpack_public_path__ + "static/media/male-7.ca92db16.jpg";